var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSoloDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.821,
    height: 62.849,
    viewBox: "0 0 62.821 62.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41024",
    "data-name": "Path 41024",
    d: "M23.044,27.234H4.19A4.189,4.189,0,0,1,0,23.044V4.19A4.189,4.189,0,0,1,4.19,0H23.044a4.189,4.189,0,0,1,4.19,4.19V23.044a4.189,4.189,0,0,1-4.19,4.19m39.777-4.19V4.19A4.189,4.189,0,0,0,58.631,0H39.777a4.19,4.19,0,0,0-4.19,4.19V23.044a4.19,4.19,0,0,0,4.19,4.19H58.631a4.189,4.189,0,0,0,4.19-4.19m0,35.614V39.8a4.189,4.189,0,0,0-4.19-4.19H39.777a4.19,4.19,0,0,0-4.19,4.19V58.659a4.19,4.19,0,0,0,4.19,4.19H58.631a4.189,4.189,0,0,0,4.19-4.19m-35.587,0V39.8a4.189,4.189,0,0,0-4.19-4.19H4.19A4.189,4.189,0,0,0,0,39.8V58.659a4.189,4.189,0,0,0,4.19,4.19H23.044a4.189,4.189,0,0,0,4.19-4.19",
    fill: "#56aa1c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSoloDevices);
export default __webpack_public_path__ + "static/media/payment_solo_devices.d852e0f5fda3676121f82201e203b319.svg";
export { ForwardRef as ReactComponent };